// Imports
//=require ../source/js/modernizr-custom.js
//=require svg4everybody/dist/svg4everybody.min.js
//=require lazysizes/lazysizes.min.js
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js

svg4everybody();

function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

// DOM
var MyApp = {

    onlyNumbers: function () {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    },
    onlyLetters: function () {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    },
    onlyAlphaNumeric: function () {
        $('.only-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    },
    onlyPhone: function () {
        $('.only-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
        $('.only-phone').mask('000-000-0000');
    },
    onlyDate: function () {
        $('.only-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
    },
    quote: {
        form: function () {
            $.validator.methods.email = function (value, element) {
                if (value == '')
                    return true;

                var regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.([A-Z]{2,})+$/i;
                if (!regex.test(value)) {
                    return false;
                } else {
                    return true;
                }
            }

            jQuery.validator.addMethod('date', function (value, element) {
                return this.optional(element) || /^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}$/.test(value);
            }, 'Please enter a valid date.');

            jQuery.validator.addMethod('over19', function (value, element) {
                currentYear = new Date().getFullYear();
                value = currentYear - (value.substr(value.length - 4));
                if (value >= 19) {
                    return true;
                } else {
                    return false;
                }
            }, 'The person\' age must be 19 or over.');

            jQuery.validator.addMethod('under100', function (value, element) {
                currentYear = new Date().getFullYear();
                value = currentYear - (value.substr(value.length - 4));
                if (value < 100) {
                    return true;
                } else {
                    return false;
                }
            }, 'Please enter a valid date.');

            $('.quote').validate({
                errorClass: 'quote__error',
                submitHandler: function (form) {
                    $(form).addClass('quote_loading');
                    form.submit();
                }
            });
            if ($('#firstName').length) {
                $('#firstName').rules('add', {
                    required: true,
                    minlength: 2,
                    messages: {
                        required: 'Enter your first name'
                    }
                });
            }
            if ($('#lastName').length) {
                $('#lastName').rules('add', {
                    required: true,
                    minlength: 2,
                    messages: {
                        required: 'Enter your last name'
                    }
                });
            }
            if ($('#email').length) {
                $('#email').rules('add', {
                    required: true,
                    minlength: 3,
                    maxlength: 255,
                    messages: {
                        required: 'Enter your email'
                    }
                });
            }
            if ($('#phone').length) {
                $('#phone').rules('add', {
                    required: true,
                    minlength: 12,
                    maxlength: 12,
                    messages: {
                        required: 'Enter your phone number',
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                    }
                });
            }
            if ($('#zipcode').length) {
                $('#zipcode').rules('add', {
                    required: true,
                    digits: true,
                    minlength: 3,
                    maxlength: 5,
                    remote: {
                        url: 'https://thorv2.confiejarvis.com/thor/javascript?',
                        data: {
                            zipcode: function () { return $('#zipcode').val(); }
                        },
                        dataFilter: function (data) {
                            if (data === "1") {
                                return '"true"';
                            }
                            return '"Enter a valid zip code"';
                        }
                    },
                    messages: {
                        required: 'Enter your zip code'
                    }
                });
            }
        }
    },
    giftCard: {
        close: function () {
            $('.gift-card-banner__close').on('click', function () {
                $('.gift-card-banner').slideUp();
            })
        }
    }
}

// On ready

$(function () {

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }
    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }
    if ($('.only-alpha-numeric').length) {
        MyApp.onlyAlphaNumeric();
    }
    if ($('.only-phone').length) {
        MyApp.onlyPhone();
    }
    if ($('.quote').length) {
        MyApp.quote.form();
    }
    if($('.gift-card-banner__close').length) {
        MyApp.giftCard.close();
    }
});

const osanoTrigger = {
    trigger: document.querySelector('.js-osano-trigger'),
    init() {
        this.trigger?.addEventListener('click', event => {
            event.preventDefault();
            Osano.cm.showDoNotSell();
            const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
            closeButtonDialog?.focus();
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});
const replaceHyphens = {
    treeWalker: document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        {
            acceptNode(node) {
                if (node.parentElement && node.parentElement.closest('.banner-form')) {
                    return NodeFilter.FILTER_ACCEPT;
                }
                return NodeFilter.FILTER_REJECT;
            }
        },
        false
    ),
    searchAndReplace() {
        while (this.treeWalker.nextNode()) {
            this.treeWalker.currentNode.textContent = this.treeWalker.currentNode.textContent.replaceAll(/-|–/g, '‑');
        }
    }
};

replaceHyphens.searchAndReplace();
